import { getIdentityTransaction, updateIdentityTransaction } from "../gateway/identityTransaction";

const CONTINUE_FALLBACK_URL = "https://continue.clikkle.com/";
const REDIRECT_STORAGE_KEY = "clikkle.accounts.redirectto"; // deprecated compatibility export

function isBlankRedirect(value) {
  return !value || value === "null" || value === "undefined";
}

function isTrustedRedirect(url) {
  const hostname = url.hostname.toLowerCase();
  if (url.protocol === "https:" && (hostname === "clikkle.com" || hostname.endsWith(".clikkle.com"))) return true;
  if (url.protocol !== "http:") return false;
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname.startsWith("192.168.") || hostname.startsWith("10.") || /^172\.(1[6-9]|2\d|3[01])\./.test(hostname);
}

export function normalizeRedirectUrl(value) {
  if (isBlankRedirect(value)) return "";
  try {
    const url = new URL(value, window.location.origin);
    return isTrustedRedirect(url) ? url.toString() : "";
  } catch {
    return "";
  }
}

export function rememberRedirectUrl(value) {
  const normalized = normalizeRedirectUrl(value);
  if (normalized) updateIdentityTransaction({ redirectUri: normalized });
  return normalized;
}

export function resolveRedirectUrl(explicitValue) {
  const query = new URLSearchParams(window.location.search);
  return normalizeRedirectUrl(explicitValue) || normalizeRedirectUrl(query.get("redirect_uri") || query.get("redirectto")) || normalizeRedirectUrl(getIdentityTransaction()?.redirectUri);
}

export function clearRememberedRedirectUrl() {
  updateIdentityTransaction({ redirectUri: "" });
}

export function buildAuthenticatedDestination({ redirectUrl, userId, refreshToken, security }) {
  const resolved = resolveRedirectUrl(redirectUrl) || CONTINUE_FALLBACK_URL;
  const destination = new URL(resolved);
  const methods = security?.availableMethods || [];
  const securityLevel = methods.includes("authenticator") ? "strong" : "basic";
  const transaction = getIdentityTransaction();

  // Store compatibility bridge: keep reusable callback credentials out of the
  // HTTP request URL/server logs. Store consumes and immediately scrubs this
  // fragment. Authorization Code + PKCE replaces this bridge in the target flow.
  if (transaction?.clientId === "store") {
    const callback = new URLSearchParams();
    if (userId) callback.set("userId", userId);
    if (refreshToken) callback.set("refreshToken", refreshToken);
    callback.set("securityLevel", securityLevel);
    destination.hash = `identity_callback?${callback.toString()}`;
    return destination.toString();
  }

  if (userId) destination.searchParams.set("userId", userId);
  if (refreshToken) destination.searchParams.set("refreshToken", refreshToken);
  destination.searchParams.set("securityLevel", securityLevel);
  return destination.toString();
}

export { CONTINUE_FALLBACK_URL, REDIRECT_STORAGE_KEY };
